var map = {
	"./emotion-except-afraid.png": 52689,
	"./emotion-except-angry.png": 79133,
	"./emotion-except-happy.png": 36884,
	"./emotion-except-neutral.png": 75887,
	"./emotion-except-sad.png": 8466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37966;